import React, { useEffect, useState } from "react";
import { ModalAlert, Notice } from "components/common-ui";
import SelectAccount from "./select-account";

type SelectAccountsProps = {
    display: boolean,
    cancellationToken: any,
    accounts: any,
    onSelect: any,
    onTryOtherDetails: any
}

const SelectAccounts = (props: SelectAccountsProps) => {
    const { display, cancellationToken, accounts, onSelect, onTryOtherDetails } = props;
    const getSelectedAccounts = () => accounts.filter((x: { isSelected: boolean; }) => x.isSelected === true);
    const [selectionCount, setSelectionCount] = useState<number>(0);

    useEffect(() => {
        // const copy = JSON.parse(JSON.stringify(accounts));
        // accounts.push(copy[0]);
        // accounts.push(copy[1]);

        setSelectionCount(accounts?.filter((x: { isSelected: boolean; }) => x.isSelected)?.length ?? 0);
    }, [accounts]);

    const select = (e: any) => {
        if (e != null) {
            e.preventDefault();
        }

        const selectedAccounts = getSelectedAccounts();

        if (selectedAccounts.length === 0) {
            ModalAlert.error("You must select at least one account");
            return;
        }

        onSelect(selectedAccounts);
    }

    const accountSelected = (isSelected: boolean) => {
        setSelectionCount(getSelectedAccounts().length);
    }

    const tryOtherDetails = (e: any) => {
        if (e != null) {
            e.preventDefault();
        }

        cancellationToken.cancel();

        onTryOtherDetails();
    }

    if (display !== true || accounts == null || accounts?.length === 0) {
        return null;
    }

    const isDisabled = selectionCount === 0;
    const submitButtonCssName = isDisabled ? " disabled" : "";

    return (
        <Notice className="select-accounts">
            <h1>Select your account</h1>

            <p>
                Please select which account(s) you would like to link to your profile:
            </p>

            <ul className="select-accounts">
                {accounts ? accounts.map((a: any, index: number) =>
                    <SelectAccount key={index} id={`cb-${index}`} account={a} onChange={accountSelected} />)
                    : null}
            </ul>

            <button
                className={`btn btn-black${submitButtonCssName}`}
                disabled={isDisabled}
                onClick={select}>Select these DStv Account(s)</button>

            <p className="retry">
                Not your account?&nbsp;
                <span className="anchor try-again" onClick={tryOtherDetails}>Try other details</span>
            </p>
        </Notice>
    );
}

export default SelectAccounts;
